"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["fill"];
const _hoisted_3 = ["fill"];
exports.default = (0, vue_1.defineComponent)({
    __name: 'SuccessIcon',
    props: {
        size: { default: "100px" },
        outlineColor: { default: "#D0E5A8" },
        checkColor: { default: "#AEE852" }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", {
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                x: "0px",
                y: "0px",
                "xml:space": "preserve",
                viewBox: "0 0 85 85",
                width: __props.size,
                height: __props.size
            }, [
                (0, vue_2.createElementVNode)("path", {
                    fill: __props.outlineColor,
                    d: "M42.45,80.07c-20.67,0-37.48-16.82-37.48-37.48C4.97,21.92,21.79,5.1,42.45,5.1s37.48,16.81,37.48,37.48\n            C79.94,63.25,63.12,80.07,42.45,80.07z M42.45,7.89c-19.13,0-34.7,15.57-34.7,34.7c0,19.13,15.56,34.7,34.7,34.7\n      s34.7-15.56,34.7-34.7C77.15,23.46,61.59,7.89,42.45,7.89z"
                }, null, 8 /* PROPS */, _hoisted_2),
                (0, vue_2.createElementVNode)("path", {
                    fill: __props.checkColor,
                    d: "M35.81,58.67c-0.52,0-1.01-0.21-1.38-0.57L21.37,45.04c-0.76-0.76-0.76-2,0-2.76c0.76-0.76,2-0.76,2.76,0\n      l11.68,11.68l25.52-25.53c0.76-0.76,2-0.76,2.76,0c0.76,0.76,0.76,2,0,2.76l-26.9,26.9C36.82,58.46,36.33,58.67,35.81,58.67z"
                }, null, 8 /* PROPS */, _hoisted_3)
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
